<template>
  <div class="userLayout">
    <div class="navLeft">
      <el-row class="tac">
        <el-col >
          <el-menu default-active="/dataCenter" class="el-menu-vertical-demo" router unique-opened>
            <el-menu-item index="/dataCenter">
              <i class="el-icon-menu"></i>
              <span slot="title">数据中心</span>
            </el-menu-item>

            <el-submenu index="1">
              <template slot="title">
                <i class="el-icon-s-custom"></i>
                <span>我的</span>
              </template>
              <el-menu-item index="/myApi">我的API</el-menu-item>
              <el-menu-item index="/applyApi">申请API</el-menu-item>
              <el-menu-item index="/myOrder">我的订单</el-menu-item>
              <el-menu-item index="/myBookMatch">我的匹配任务</el-menu-item>
            </el-submenu>

            <el-submenu index="2">
              <template slot="title">
                <i class="el-icon-setting"></i>
                <span>账号管理</span>
              </template>
              <el-menu-item index="/updatePwd">修改密码</el-menu-item>
            </el-submenu>
          </el-menu>
        </el-col>
      </el-row>
    </div>
    <div class="navRight">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
export default {
  methods: {}
}
</script>

<style lang="less" scoped>
.userLayout {
  display: flex;
  justify-content: space-between;
  height: 100vh;
  .navLeft {
    width: 20%;
    //height: 100%;
    border-right: solid 1px #e6e6e6;
    border-collapse: collapse;
    .el-menu {
    border-right: none;
}
  }
  .navRight {
    width: 80%;
  }
}

/* 移动端适配 - 不影响PC端 */
@media screen and (max-width: 768px) {
  .userLayout {
    display: block;
    background: #fff;

    .navLeft {
      width: 100%;
      border-right: none;
      border-bottom: solid 1px #e6e6e6;
      background: #fff;

      .el-row, .el-col {
        width: 100%;
      }

      .el-menu {
        display: block;
        border-bottom: none;
      }

      .el-menu-item, .el-submenu > .el-submenu__title {
        text-align: left;
        padding-left: 20px;
        border-bottom: 1px solid #f0f0f0;
        height: 48px;
        line-height: 48px;
      }

      .el-submenu .el-menu {
        background: #fafafa;
        display: none;
      }

      .el-submenu.is-active .el-menu {
        display: block;
      }

      .el-submenu .el-menu-item {
        text-align: left;
        padding-left: 50px;
        font-size: 13px;
        height: 44px;
        line-height: 44px;
      }
    }

    .navRight {
      width: 100%;
      padding: 0;
    }
  }
}
</style>
